export default "__VITE_ASSET__DGKlsgsu__"